import { createAsyncThunk } from '@reduxjs/toolkit';
import { getLatestProjectsClockedIn } from '../services/getLatestProjectsClockedIn.service';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';

export const loadLatestProjectsClockedInTo = createAsyncThunk(
  'projects/loadLatestProjectsClockedInTo',
  async (_, { getState }) => {
    const activeEmployerInfo = selectUserActiveEmployerInfo(getState());

    const projectIds = await getLatestProjectsClockedIn(activeEmployerInfo);

    return projectIds;
  }
);
